// eslint-disable-next-line import/no-cycle
import { isExternalLink } from '../../foreground/utils/chunkedScrolling';
import { getATagAncestor } from './getATagAncestor';
import { getScrollingManager } from './getScrollingManager';
import type { MobileContentFrameWindow } from './types';

declare let window: MobileContentFrameWindow;

const onPointerUp = (e: Event) => {
  // TODO: so it works with stylus too
};

const onClick = (e: Event) => {
  const event = e || window.event;
  // claude eslint: click event target in the document is always an HTMLElement
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  const element = (event.target ?? event.srcElement) as HTMLElement;
  const aTagAncestor = getATagAncestor(element);

  if (aTagAncestor) {
    event.preventDefault();
    event.stopPropagation();
    const href = aTagAncestor.getAttribute('href');

    if (href && !isExternalLink(href)) {
      getScrollingManager().scrollToLinkElement(href, aTagAncestor);
      return false;
    }

    window.portalGateToForeground.emit('link-clicked', aTagAncestor.href);
    return false;
  }

  event.preventDefault();
  event.stopPropagation();
};

export const setupLinks = () => {
  document.addEventListener('pointerup', onPointerUp);
  document.addEventListener('click', onClick);
};

export const destroySetupLinks = () => {
  document.removeEventListener('pointerup', onPointerUp);
  document.removeEventListener('click', onClick);
};
